import React from 'react';
import { ITypeRichTextFields, transformCloudinaryUrl } from '@adac-mp/shared';
import { ChevronRight, Button, Typography, Richtext } from '../../index';
import { withTracking } from '../../utils/tracking/tracking';

type Image = {
	src: string;
	alt: string;
};

type Link = {
	label: React.ReactNode;
	href: string;
};

interface ITeaserProps {
	image: Image;
	title: string;
	description: ITypeRichTextFields | React.ReactNode;
	link: Link;
	className?: string;
	teasersCount: number;
}

export const TeaserComponent = ({ image, title, description, link, teasersCount, className = '' }: ITeaserProps) => {
	const hasLinkLabel = link.label || false;
	const renderTeaserWrapper = (compoenent: JSX.Element) =>
		link?.label ? (
			compoenent
		) : (
			<a className={`flex no-underline ${className}`} href={link.href} target="_blank">
				{compoenent}
			</a>
		);
	const renderTeaserLink = () => (
		<span className="w-full px-4 pb-4 mt-[20px] md:mt-4 flex grow items-end">
			<Button
				href={link.href}
				size="smMd"
				className={`py-[5.5px] gap-2 w-full md:py-2 ${teasersCount < 3 ? 'md:max-w-1/2' : ''}`}
				tracking={{
					teaser_click: {
						label: title,
						element: 'Confirmation Page',
					},
				}}>
				<ChevronRight />
				{link.label}
			</Button>
		</span>
	);
	const renderTeaser = () => (
		<span
			className={`rounded bg-white relative flex flex-col flex-wrap flex-grow border border-solid border-transparent transition-[border] duration-300 ${
				!hasLinkLabel ? 'cursor-pointer hover:border-[1px] hover:border-gray-400' : ''
			} ${className}`}>
			<img
				className="aspect-video object-cover rounded-t"
				src={transformCloudinaryUrl(image.src)}
				alt={image.alt}
				width="100%"
			/>
			<span className="flex flex-col px-4 pt-3.5">
				<Typography className="mb-2" variant="header" color="title" size="xxl">
					{title}
				</Typography>
				<Typography component="span" color="title" size="baseLg">
					{React.isValidElement(description) ? (
						description
					) : (
						<Richtext document={description as ITypeRichTextFields} />
					)}
				</Typography>
			</span>
			{hasLinkLabel && renderTeaserLink()}
		</span>
	);
	return renderTeaserWrapper(renderTeaser());
};

export const Teaser = withTracking(TeaserComponent);
